import {
  Editor,
  EditorChangeEvent,
  ProseMirror,
  EditorUtils,
  EditorPasteEvent,
  PasteCleanupSettings,
  EditorIFrameInitEvent
} from "@progress/kendo-react-editor";
import { CommonTools, MobileTools } from "./CommonTools";
import { isMobile } from "react-device-detect";
import React, { useRef } from "react";
import { useReduxSelector } from "../../redux/hooks";

type EditorProps = {
  onChange: (e: EditorChangeEvent) => void;
  HTML?: string;
  height?: string;
  onIFrameInit?: (event: EditorIFrameInitEvent) => void;
  autoFocus?: boolean;
}

const TextEditor = (props: EditorProps) => {
  const { EditorState, EditorView } = ProseMirror;
  const { imageResizing, pasteCleanup, sanitize, sanitizeClassAttr, sanitizeStyleAttr, removeAttribute, replaceImageSourcesFromRtf } = EditorUtils;

  const onMount = (event) => {
    const iframeDocument = event.dom.ownerDocument;
    const style = iframeDocument.createElement("style");
    style.appendChild(iframeDocument.createTextNode(editorStyles));
    iframeDocument.head.appendChild(style);

    // Auto focus
    if (props.autoFocus === undefined || props.autoFocus === true) {
      console.warn('Auto focus', props.autoFocus);
      window.setTimeout(() => {
        event.target?.focus();
      }, 100);
    }

    // Image resize plugin
    const { plugins, doc } = event.viewProps.state;


    return new EditorView(
      { mount: event.dom },
      {
        ...event.viewProps,
        state: EditorState.create({
          doc,
          plugins: [imageResizing(), ...plugins],
        }),
      }
    );
  };
  const pasteSettings: PasteCleanupSettings = {
    convertMsLists: true,
    // stripTags: 'span|font'
    attributes: {
      class: sanitizeClassAttr,
      style: removeAttribute, //sanitizeStyleAttr,

      // keep `width`, `height` and `src` attributes
      width: () => { },
      height: () => { },
      src: () => { },

      // Removes `lang` attribute
      // lang: removeAttribute,

      // removes other (unspecified above) attributes
      '*': removeAttribute
    }
  };

  const paste = (event: EditorPasteEvent) => {

    let html = pasteCleanup(sanitize(event.pastedHtml), pasteSettings);

    // If the pasted HTML contains images with sources pointing to the local file system,
    // `replaceImageSourcesFromRtf` will extract the sources from the RTF and place them to images 'src' attribute in base64 format.
    if (event.nativeEvent.clipboardData) {
      html = replaceImageSourcesFromRtf(html, event.nativeEvent.clipboardData);
    }

    console.warn('pasted like its hot', html);

    return html;
  }


  //THis sets focus on the editor when the action is expanded
  const [showAction, setShowAction] = React.useState(0);
  const editorControl = useRef<Editor>(null);
  const actionExpanded = useReduxSelector(state => state.ticketDetailsUI.actionExpanded);

  React.useEffect(() => {
    //console.warn('Action expanded in TextEditor', editorControl.current);
    //Action expanded
    if (showAction !== actionExpanded) {
      setShowAction(actionExpanded);
      if (editorControl?.current && (actionExpanded === 1 || showAction === 1)) {
        console.warn('setTimeout focus', actionExpanded, showAction);
        window.setTimeout(() => {
          editorControl.current?.focus();
        }, 100);
      }
    }

  }, [actionExpanded]);

  return (
    <div>
      <Editor
        ref={editorControl}
        onPasteHtml={paste}
        resizable={true}
        contentStyle={{ height: props.height ? props.height : '100%' }}
        onChange={props.onChange}
        onMount={onMount}
        value={props.HTML || ''}
        tools={isMobile ? MobileTools : CommonTools}
        onIFrameInit={props.onIFrameInit}
      />
    </div>
  );
};



export default TextEditor;

export const enterKeyPlugin2 = new ProseMirror.Plugin({
  props: {
    handleKeyDown(view, event) {
      if (event.key === "Enter") {
        const { state, dispatch } = view;
        const { schema } = state;


        // Check if the current node is a list item
        let inListItem = true;//state.selection.$from.parent.type === schema.nodes.list_item;

        // If inside a list item, allow default behavior
        for (let d = state.selection.$from.depth; d > 0; d--) {
          const node = state.selection.$from.node(d);
          console.warn('handleKeyDown Enter node', node.type.name, d);
          if (node.type.name === "list_item") {
            //return false; // allow default behavior
            inListItem = true;
          }
        }

        console.warn('handleKeyDown Enter list_item FOUND!', inListItem);
        //console.warn('handleKeyDown Enter', inListItem, state.selection.$from.node(), state.selection.$from.parent, state.selection.$from);

        if (inListItem) {
          // Create a new list item
          const listItem = schema.nodes.list_item.createAndFill();
          dispatch(state.tr.insert(state.selection.$to.pos, listItem).scrollIntoView());
        } else {
          // Default behavior: create a hard break
          const br = schema.nodes.hard_break.create();
          dispatch(state.tr.replaceSelectionWith(br).scrollIntoView());
        }

        return true;
      }
      return false;
    },
  },
});


export const enterKeyPlugin = new ProseMirror.Plugin({
  props: {
    handleKeyDown(view, event) {
      //console.log('handleKeyDown', event);
      if (event.key === "Enter") {
        const { state, dispatch } = view;
        const br = state.schema.nodes.hard_break.create();
        dispatch(state.tr.replaceSelectionWith(br).scrollIntoView());
        return true;
      }
      return false;
    },
  },
});

export const editorStyles = `
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
  "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
  sans-serif;
}
div.k-content > p{margin:0 }  
`;
